import React, { useEffect, useState } from "react";
import { Button, Space, Spin, Drawer, Input, Modal, Checkbox } from "antd";
import Table from "../../../core/pagination/datatable";
import {
  CheckOutlined,
  CloseOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import {
  getApiBaseUrl,
  GET_APPROVALS,
  ADD_ACTIVITY,
  UPDATE_APPROVALS,
  LOGIN,
} from "../Config/Config";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
const { TextArea } = Input;

const ignoredKeys = [
  "Id",
  "CreatedBy",
  "UpdatedBy",
  "Type",
  "ActualBlockId",
  "currentBlockId",
  "FilterId",
];

const Approvals = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [actionType, setActionType] = useState(""); // "approve" or "reject"
  const [ScreenName, setScreenName] = useState("");
  const [remarks, setRemarks] = useState(""); // if you're using a modal
  const [updateLoading, setUpdateLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false); // optional modal
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [bulkModalVisible, setBulkModalVisible] = useState(false);
  const [authModalVisible, setAuthModalVisible] = useState(false);
  const [bulkRemarks, setBulkRemarks] = useState("");
  const [password, setPassword] = useState("");
  const [bulkActionType, setBulkActionType] = useState("approve"); // or "reject"
  const [globalLoading, setGlobalLoading] = useState(false);
  const [singlePasswordModalVisible, setSinglePasswordModalVisible] =
    useState(false);
  const [singlePassword, setSinglePassword] = useState("");
  const [singleReauthenticating, setSingleReauthenticating] = useState(false);
  const fetchApprovals = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_APPROVALS}`);
      const data = await response.json();
      setData(data.ResultData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApprovals();
  }, []);

  const handleRowSelect = (checked, id) => {
    setSelectedRowIds((prev) => {
      if (checked) {
        if (prev.length >= 10) return prev; // Limit to 10
        return [...prev, id];
      } else {
        return prev.filter((item) => item !== id);
      }
    });
  };

  const columns = [
    {
      title: "",
      key: "select",
      render: (_, record) => {
        const isPending = record.Status === 1;
        const isChecked = selectedRowIds.includes(record.Id);
        const disableCheckbox =
          !isPending || (!isChecked && selectedRowIds.length >= 10);

        return (
          <Checkbox
            checked={isChecked}
            disabled={disableCheckbox}
            onChange={(e) => handleRowSelect(e.target.checked, record.Id)}
          />
        );
      },
    },
    {
      title: "Approval Name",
      dataIndex: "ScreenName",
      key: "ScreenName",
    },
    // {
    //   title: "Attribute",
    //   key: "Attribute",
    //   render: (_, record) => {
    //     const keys = record.UpdateValues?.split(",").map((k) => k.trim()) || [];
    //     return (
    //       <div>
    //         {keys.map((key) => (
    //           <div key={key}>{key}</div>
    //         ))}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: "Old Value",
    //   key: "OldValue",
    //   render: (_, record) => {
    //     const keys = record.UpdateValues?.split(",").map((k) => k.trim()) || [];
    //     let oldObj = {};
    //     try {
    //       oldObj = JSON.parse(record.OldValues || "{}");
    //     } catch {
    //       console.log("ll");
    //     }

    //     return (
    //       <div>
    //         {keys.map((key) => (
    //           <div key={key}>
    //             {Object.prototype.hasOwnProperty.call(oldObj, key)
    //               ? oldObj[key]
    //               : "-"}
    //           </div>
    //         ))}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: "New Value",
    //   key: "NewValue",
    //   render: (_, record) => {
    //     const keys = record.UpdateValues?.split(",").map((k) => k.trim()) || [];
    //     let newObj = {};
    //     try {
    //       newObj = JSON.parse(record.NewValues || "{}");
    //     } catch {
    //       console.log("");
    //     }

    //     return (
    //       <div>
    //         {keys.map((key) => (
    //           <div key={key}>
    //             {Object.prototype.hasOwnProperty.call(newObj, key)
    //               ? newObj[key]
    //               : "-"}
    //           </div>
    //         ))}
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Status",
      key: "Status",
      fixed: "right",
      dataIndex: "Status",
      render: (status) => {
        let badgeClass = "";
        let text = "";

        if (status === 1) {
          badgeClass = "badge bg-warning text-dark";
          text = "Pending";
        } else if (status === 2) {
          badgeClass = "badge bg-success";
          text = "Approved";
        } else if (status === 3) {
          badgeClass = "badge bg-danger";
          text = "Rejected";
        }

        return <span className={badgeClass}>{text}</span>;
      },
      sorter: (a, b) => a.Status - b.Status, // enables sorting
    },
    {
      title: "Date & Time",
      key: "CreatedOn",
      dataIndex: "CreatedOn",
      render: (text) => {
        if (!text) return "NA";
        const date = new Date(text);
        const pad = (n) => (n < 10 ? "0" + n : n);
        const day = pad(date.getUTCDate());
        const month = pad(date.getUTCMonth() + 1);
        const year = date.getUTCFullYear();
        const hours = pad(date.getUTCHours());
        const minutes = pad(date.getUTCMinutes());
        const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
        return formatted.startsWith("01/01/1900") ? "NA" : formatted;
      },
      sorter: (a, b) => new Date(a.CreatedOn) - new Date(b.CreatedOn),
    },
    {
      title: "User ID",
      dataIndex: "Email",
      key: "Email",
      sorter: (a, b) => a.Email.localeCompare(b.Email),
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",

      render: (_, record) => {
        const isPending = record.Status === 1;

        return (
          <Space>
            <>
              <Button
                type="primary"
                icon={<CheckOutlined />}
                size="small"
                onClick={() => {
                  setSelectedId(record.Id);
                  setActionType("approve");
                  setScreenName(record.ScreenName);
                  setRemarks(""); // reset old input
                  setModalVisible(true); // open the modal
                }}
                disabled={!isPending || selectedRowIds.length > 0}
              />
              <Button
                type="primary"
                danger
                icon={<CloseOutlined />}
                size="small"
                onClick={() => {
                  setSelectedId(record.Id);
                  setActionType("reject");
                  setScreenName(record.ScreenName);
                  setRemarks(""); // reset old input
                  setModalVisible(true); // open the modal
                }}
                disabled={!isPending || selectedRowIds.length > 0}
              />
            </>

            <Button
              icon={<EyeOutlined />}
              size="small"
              onClick={() => openDrawer(record)}
            />
          </Space>
        );
      },
    },
  ];

  const openDrawer = (record) => {
    setSelectedRecord(record);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setSelectedRecord(null);
  };

  const handleSubmit = async () => {
    setUpdateLoading(true);
    setGlobalLoading(true);
    const user = JSON.parse(sessionStorage.getItem("user"));

    const payload = {
      Id: selectedId,
      Status: actionType === "approve" ? 2 : 3,
      Remarks: remarks.trim(),
      UpdatedBy: user?.UserID,
    };

    let isSuccess = 0;

    try {
      const response = await fetch(`${getApiBaseUrl()}${UPDATE_APPROVALS}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      isSuccess =
        data?.Status && data?.ResultData?.[0]?.Status === "Success" ? 1 : 0;

      if (response.ok && isSuccess) {
        Swal.fire("Success", "Action completed successfully!", "success");
        setModalVisible(false);
      } else {
        Swal.fire("Error", "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("API Error:", error);
      Swal.fire("Error", "Request failed!", "error");
      isSuccess = 0;
    } finally {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user?.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: `${
              actionType === "approve" ? "Approved" : "Rejected"
            } ${ScreenName}`,
            Location: "updateApprovalSetting",
            IsSucces: isSuccess,
          }),
        });
      } catch (auditErr) {
        console.error("Audit log error:", auditErr);
      }
      setUpdateLoading(false);
      setGlobalLoading(false);
      fetchApprovals();
    }
  };

  const handleReauthenticate = async () => {
    setSingleReauthenticating(true);
    const user = JSON.parse(sessionStorage.getItem("user"));

    try {
      const response = await fetch(`${getApiBaseUrl()}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user.UserName,
          password: singlePassword,
        }),
      });

      const data = await response.json();

      if (response.ok && data?.status) {
        setSinglePasswordModalVisible(false);
        setSinglePassword("");
        handleSubmit(); // Proceed
      } else {
        Swal.fire(
          "Authentication Failed",
          data?.Message || "Invalid password",
          "error"
        );
      }
    } catch (err) {
      console.error("Re-authentication error:", err);
      Swal.fire("Error", "Authentication request failed!", "error");
    } finally {
      setSingleReauthenticating(false);
    }
  };

  return (
    <>
      {globalLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      My Tasks
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your Approvals here</h6>
              </div>
            </div>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
              <div className="search-set m-3"></div>

              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
              <div className="mb-3 d-flex flex-wrap gap-2">
                {selectedRowIds.length > 0 && (
                  <Space style={{ marginBottom: 16 }}>
                    <Button
                      type="primary"
                      icon={<CheckOutlined />}
                      onClick={() => {
                        setBulkActionType("approve");
                        setBulkModalVisible(true);
                      }}
                    >
                      Bulk Approve
                    </Button>
                    <Button
                      danger
                      icon={<CloseOutlined />}
                      onClick={() => {
                        setBulkActionType("reject");
                        setBulkModalVisible(true);
                      }}
                    >
                      Bulk Reject
                    </Button>
                  </Space>
                )}
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : data.length > 0 ? (
                  <Table columns={columns} dataSource={data} bordered />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <Drawer
          title="Approval Details"
          placement="right"
          onClose={closeDrawer}
          open={drawerOpen}
          width={600}
        >
          {selectedRecord?.Approvaltype === 1 ? (
            <AddView data={selectedRecord} />
          ) : (
            <UpdateView data={selectedRecord} />
          )}
        </Drawer>

        <Modal
          title={`${
            actionType === "approve" ? "Approval" : "Rejection"
          } Remarks`}
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setModalVisible(false)}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={updateLoading}
              onClick={() => setSinglePasswordModalVisible(true)}
            >
              Submit
            </Button>,
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Optional remarks (leave blank if not applicable)"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </Modal>

        <Modal
          title="Confirm Password"
          open={singlePasswordModalVisible}
          onCancel={() => {
            setSinglePasswordModalVisible(false);
            setSinglePassword("");
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => setSinglePasswordModalVisible(false)}
            >
              Cancel
            </Button>,
            <Button
              key="confirm"
              type="primary"
              loading={singleReauthenticating}
              onClick={handleReauthenticate}
            >
              Confirm
            </Button>,
          ]}
        >
          <Input.Password
            placeholder="Enter your password"
            value={singlePassword}
            onChange={(e) => setSinglePassword(e.target.value)}
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Modal>

        <Modal
          title={`Confirm Bulk ${
            bulkActionType === "approve" ? "Approval" : "Rejection"
          }`}
          open={bulkModalVisible}
          onCancel={() => {
            setBulkModalVisible(false);
            setBulkRemarks("");
          }}
          onOk={() => {
            if (!bulkRemarks.trim()) {
              Swal.fire("Remarks Required", "Please enter remarks.", "warning");
              return;
            }
            setAuthModalVisible(true); // Show password modal
          }}
          okText={`Continue ${
            bulkActionType === "approve" ? "Approval" : "Rejection"
          }`}
        >
          <p>Please enter remarks for selected items:</p>
          <Input.TextArea
            rows={4}
            value={bulkRemarks}
            onChange={(e) => setBulkRemarks(e.target.value)}
            placeholder="Enter remarks"
          />
        </Modal>

        <Modal
          title="Re-authentication"
          open={authModalVisible}
          onCancel={() => {
            setAuthModalVisible(false);
            setPassword("");
          }}
          onOk={async () => {
            const user = JSON.parse(sessionStorage.getItem("user"));
            if (!password) {
              Swal.fire(
                "Password Required",
                "Please enter your password.",
                "warning"
              );
              return;
            }
            setGlobalLoading(true);
            try {
              const loginResponse = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  username: user?.UserName,
                  password: password,
                }),
              });

              const loginData = await loginResponse.json();

              if (!loginData?.status) {
                Swal.fire(
                  "Authentication Failed",
                  "Incorrect password.",
                  "error"
                );
                return;
              }

              // Now proceed with approval + audit
              const status = bulkActionType === "approve" ? 2 : 3;
              const payloads = selectedRowIds.map((id) => {
                const rowData = data.find((row) => row.Id === id);

                return {
                  apiPayload: {
                    Id: id,
                    Status: status,
                    Remarks: bulkRemarks.trim(),
                    UpdatedBy: user?.UserID,
                  },
                  screenName: rowData?.ScreenName || "", // used for audit only
                };
              });

              let allSucceeded = true;
              for (const { apiPayload, screenName } of payloads) {
                let isSuccess = false;

                try {
                  const response = await fetch(
                    `${getApiBaseUrl()}${UPDATE_APPROVALS}`,
                    {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(apiPayload),
                    }
                  );

                  isSuccess = response.ok;

                  if (!isSuccess) {
                    allSucceeded = false;
                    console.error(`Failed for ID: ${apiPayload.Id}`);
                  }

                  // AUDIT LOG
                  await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      ActivityType: 1,
                      PerformedBy: user?.UserID,
                      PerformedOn: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                      Notes: `${
                        bulkActionType === "approve" ? "Approved" : "Rejected"
                      } ${screenName}`,
                      Location: "login",
                      IsSucces: isSuccess ? 1 : 0,
                    }),
                  });

                  await new Promise((res) => setTimeout(res, 100));
                } catch (error) {
                  console.error("Error during bulk operation:", error);
                }
              }

              if (allSucceeded) {
                Swal.fire(
                  "Success",
                  `All records ${bulkActionType}d successfully.`,
                  "success"
                );
              } else {
                Swal.fire(
                  "Partial Success",
                  `Some records failed to ${bulkActionType}.`,
                  "warning"
                );
              }

              // Reset
              setSelectedRowIds([]);
              setBulkRemarks("");
              setPassword("");
              setAuthModalVisible(false);
              setBulkModalVisible(false);
              fetchApprovals();
            } catch (error) {
              console.error("Error:", error);
              Swal.fire(
                "Error",
                "Something went wrong during approval.",
                "error"
              );
            } finally {
              setGlobalLoading(false);
            }
          }}
          okText={`${bulkActionType === "approve" ? "Approve" : "Reject"}`}
        >
          <p>Please enter your password to continue:</p>
          <Input.Password
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            autoComplete="new-password"
            onPaste={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}
          />
        </Modal>
      </div>
    </>
  );
};

const AddView = ({ data }) => {
  // const newValues = JSON.parse(data?.NewValues || "{}");
  let newValues = {};

  if (typeof data?.NewValues === "string") {
    try {
      newValues = JSON.parse(data.NewValues);
    } catch (e) {
      console.warn("Failed to parse NewValues:", data.NewValues);
    }
  } else if (typeof data?.NewValues === "object" && data?.NewValues !== null) {
    newValues = data.NewValues;
  }

  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Attribute</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(newValues)
          .filter(([key]) => !ignoredKeys.includes(key))
          .map(([key, value]) => (
            <tr key={key}>
              <td>{key}</td>
              <td>{value ?? "-"}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

const UpdateView = ({ data }) => {
  const oldValues = JSON.parse(data?.OldValues || "{}");
  const newValues = JSON.parse(data?.NewValues || "{}");

  // Get all keys from newValues (exclude ignored ones)
  const allKeys = Object.keys(newValues).filter(
    (key) => !ignoredKeys.includes(key)
  );

  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Attribute</th>
          <th>Old Value</th>
          <th>New Value</th>
        </tr>
      </thead>
      <tbody>
        {allKeys.map((key) => {
          const oldVal = oldValues[key] ?? "-";
          const newVal = newValues[key] ?? "-";
          const changed = oldVal !== newVal;

          return (
            <tr key={key}>
              <td className={changed ? "bg-warning fw-bold text-white" : ""}>
                {key}
              </td>
              <td className={changed ? "bg-warning fw-bold text-white" : ""}>
                {oldVal}
              </td>
              <td className={changed ? "bg-warning fw-bold text-white" : ""}>
                {newVal}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

AddView.propTypes = {
  data: PropTypes.shape({
    NewValues: PropTypes.string.isRequired,
  }).isRequired,
};

UpdateView.propTypes = {
  data: PropTypes.shape({
    OldValues: PropTypes.string.isRequired,
    NewValues: PropTypes.string.isRequired,
    UpdateValues: PropTypes.string.isRequired,
  }).isRequired,
};

export default Approvals;
